import BootstrapTable from 'react-bootstrap-table-next'
import FolderContext from '../contexts/FolderContext'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import RowsContext from './RowsContext'
import produce from 'immer'
import queryString from 'query-string'
import { Link, withRouter } from 'react-router-dom'
import {
  bytesFormatter,
  processStatusConstants,
} from '../utils/fileSizeFunctions'
import { dateFormatter } from '../utils/dateFunctions'
import { getFileIcon } from '../utils/listFunctions'
import FileIconRow from './FileIconRow'
import FileRowActionsMenu from './FileRowActionsMenu'
import { get, filter } from 'lodash'
import routes from '../routes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'

class FileListTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedRows: get(props, 'selectedRows', []),
      files: get(props, 'fileConnection.files', []),
      totalCount: get(props, 'fileConnection.totalCount', 0),
      imageFiles: filter(get(props, 'fileConnection.files', []), function (o) {
        return o.contentType.includes('image')
      }),
    }

    // function binds
    this.onTableChange = this.onTableChange.bind(this)
    this.handleOnCheckBoxChange = this.handleOnCheckBoxChange.bind(this)
    this.handleTitleTextChange = this.handleTitleTextChange.bind(this)

    this.histUnlisten = this.props.history.listen(() => {
      this.setState(
        produce((draft) => {
          draft.selectedRows = []
        })
      )
    })
  }

  handleOnCheckBoxChange(e, row) {
    e.persist()
    let activeUseForPreview = this.state.files.findIndex(
      (item) => item.useForPreview === true
    )
    let index = this.state.files.findIndex((item) => item.key === row.key)

    this.setState((prevState) => {
      const files = [...prevState.files]
      if (activeUseForPreview !== -1) {
        files[activeUseForPreview] = {
          ...files[activeUseForPreview],
          useForPreview: false,
        }
      }
      files[index] = { ...files[index], useForPreview: e.target.checked }
      return { files }
    })
    if (this.state.files[activeUseForPreview]) {
      if (this.state.files[activeUseForPreview].title) {
        this.addChanges(
          this.state.files[activeUseForPreview],
          this.state.files[activeUseForPreview].title,
          false
        )
      } else {
        this.addChanges(this.state.files[activeUseForPreview], '', false)
      }
    }
    if (this.state.files[index]) {
      if (this.state.files[index].title) {
        this.addChanges(
          this.state.files[index],
          this.state.files[index].title,
          e.target.checked
        )
      } else {
        this.addChanges(this.state.files[index], '', e.target.checked)
      }
    }
  }

  handleTitleTextChange(row, e) {
    e.persist()
    let index = this.state.files.findIndex((item) => item.key === row.key)
    this.setState((prevState) => {
      const files = [...prevState.files]
      files[index] = { ...files[index], title: e.target.value }
      return { files }
    })
    this.addChanges(
      this.state.files[index],
      e.target.value,
      this.state.files[index].useForPreview
    )
  }

  addChanges(row, textChange, previewChange) {
    this.props.addChanges(row, textChange, previewChange)
  }

  componentWillUnmount() {
    this.histUnlisten()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.fileConnection !== this.props.fileConnection) {
      this.setState({
        files: get(this.props, 'fileConnection.files', []),
        totalCount: get(this.props, 'fileConnection.totalCount', 0),
      })
    }
  }

  onTableChange(type, newState) {
    const search = queryString.parse(this.props.location.search)

    switch (type) {
    case 'pagination':
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: queryString.stringify(
          Object.assign({}, search, {
            page: newState.page,
            max: newState.sizePerPage,
          })
        ),
      })

      break
    case 'sort':
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: queryString.stringify(
          Object.assign({}, search, {
            sort: newState.sortField,
            order: newState.sortOrder,
          })
        ),
      })
      break

    default:
      console.error(`Case: ${type} not handled for table`)
    }
  }

  resetFiles = (fileIndex, newfile) => {
    let fileArr = [...this.state.files]
    fileArr[fileIndex] = newfile
    this.setState({ files: fileArr })
  }

  render() {
    const columns = [
      {
        dataField: 'name',
        text: 'Name',
        sort: false,
        classes: 'td-name',
        formatter: (cell, row) => {
          let itemId = `${this.props.itemId}`
          let length = itemId.length
          if (row.key) cell = row.key.substring(length + 1)
          return (
            <div className="text-collapse">
              <div className="table-icon-left">{getFileIcon(cell)}</div>
              <div className="table-row-title ">
                <Link
                  to={
                    row.cuid
                      ? `${routes.itemPath}/${itemId}/file/${row.cuid}`
                      : `${routes.itemPath}/${this.props.itemId}/file/${row.name}`
                  }
                  title={cell}
                >
                  {cell}
                </Link>
                <div className="table-icon-right">
                  <FileIconRow file={row} />{' '}
                  {row.processStatus === 'unzipped' ? (
                    <>
                      <span>
                        <FontAwesomeIcon icon={faBoxOpen} />{' '}
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          )
        },
      },
      {
        dataField: 'contentType',
        text: 'Type',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'size',
        text: 'File Size',
        sort: false,
        formatter: (cell) => {
          return bytesFormatter(cell, 2)
        },
      },
      {
        dataField: 'location',
        text: 'Location',
        sort: false,
        formatter: (cell, row) => {
          let location = ''
          if (row.published) location = 'SB Public Cloud'
          if (row.movedToS3) cell = 's3'

          switch (cell) {
          case 's3':
            return row.published ? location : 'SB Cloud'
          case 's3_backed':
            return row.published
              ? 'On Premise + SB Legacy Cloud + ' + location
              : 'On Premise + SB Legacy Cloud'
            //eslint-disable-next-line
          case 'disk':
            return row.published ? 'On Premise + ' + location : 'On Premise'
          default:
            return 'On Premise'
          }
        },
      },
      {
        dataField: 'input',
        text: 'Title',
        formatter: (_, row) => {
          return (
            <input
              type="text"
              name={row.key}
              id={row.key}
              cuid={row.cuid}
              title={row.title}
              size="20"
              onChange={(e) => this.handleTitleTextChange(row, e)}
              value={row.title || ''}
            ></input>
          )
        },
      },
      {
        dataField: 'checkbox',
        text: 'Image Preview',
        hidden: !this.state.imageFiles || this.state.imageFiles.length < 2,
        formatter: (_, row) => {
          return (
            <div>
              { row.contentType.includes('image') && !row.contentType.includes('geotiff') ? (
                <input
                  type="radio"
                  checked={row.useForPreview}
                  onChange={(e) => this.handleOnCheckBoxChange(e, row)}
                  name={row.key}
                  id={row.key}
                  cuid={row.cuid}
                  title={row.title}
                ></input>
              ) : (
                ''
              )}
            </div>
          )
        },
      },
      {
        dataField: 'uploadedBy',
        text: 'last Updated User',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'dateUploaded',
        text: 'Last Updated Date',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{dateFormatter(cell)}</div>
        },
      },
      {
        dataField: 'processStatus',
        text: 'Status',
        sort: false,
        formatter: (cell, row) => {
          switch (cell) {
          case processStatusConstants.UPLOAD_SUCCESS:
            cell = 'File uploaded, scanning'
            break
          case processStatusConstants.UPLOAD_FAILED:
            cell = 'File upload failed'
            break
          case processStatusConstants.SCAN_SUCCESS:
            cell = 'File scanned, clean'
            break
          case processStatusConstants.SCAN_FAILED:
            cell = 'File scanned, infected'
            break
          case processStatusConstants.SCAN_SKIPPED:
            cell = 'File scanned, skipped'
            break
          default:
            if (row.pathOnDisk == '__s3__'){
              cell = 'File uploaded, scanning'
            } else {
              cell = 'Stored'
            }
          }
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'button',
        text: 'Actions Menu',
        align: 'center',
        formatter: (_, row, rowIndex) => {
          return (
            <FileRowActionsMenu
              row={row}
              itemId={this.props.itemId}
              canWrite={this.props.canWrite}
              resetFiles={this.resetFiles}
              rowIndex={rowIndex}
              distributionLinks={this.props.distributionLinks}
            />
          )
        },
      },
    ]
    return (
      <RowsContext.Provider value={this.state}>
        <div className="sb-table-listing">
          <BootstrapTable
            responsive
            wrapperClasses="table-responsive"
            keyField="name"
            data={this.state.files}
            columns={columns}
            noDataIndication="This folder has no files yet."
            bordered={false}
            hover
            remote={{
              filter: true,
              pagination: true,
              sort: true,
              cellEdit: false,
            }}
            onTableChange={this.onTableChange}
          />
        </div>
      </RowsContext.Provider>
    )
  }
}

FileListTable.propTypes = {
  addChanges: PropTypes.func,
  itemId: PropTypes.string,
  fileConnection: PropTypes.shape({
    files: PropTypes.array,
    totalCount: PropTypes.number,
  }),
  // The react specific route context
  parentId: PropTypes.string,
  // An optional prefix to prepend to the path when sending to the server
  queryVariables: PropTypes.shape({
    parentId: PropTypes.string,
    path: PropTypes.string,
    max: PropTypes.number,
    offset: PropTypes.number,
    sort: PropTypes.string,
    order: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  }),
  match: PropTypes.shape({
    url: PropTypes.string,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  canWrite: PropTypes.bool,
  distributionLinks: PropTypes.array,
}

export default withRouter(FileListTable)

FileListTable.contextType = FolderContext
